import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

/**
 * @description Validador personalizado para asegurar que un número tenga máximo dos decimales
 * @function twoDecimalPlacesValidator
 * @returns {ValidatorFn} Función validadora que verifica el formato decimal
 *
 * @example
 * // Uso en un FormControl
 * const control = new FormControl('', [twoDecimalPlacesValidator()]);
 *
 * // Uso en un FormGroup
 * const form = new FormGroup({
 *   amount: new FormControl('', [twoDecimalPlacesValidator()])
 * });
 *
 * @remarks
 * - Acepta números enteros (ej: "123")
 * - Acepta números con un decimal (ej: "123.4")
 * - Acepta números con dos decimales (ej: "123.45")
 * - Rechaza números con más de dos decimales (ej: "123.456")
 * - Retorna null si el valor es válido
 * - Retorna { twoDecimalPlaces: true } si el valor es inválido
 */
export function twoDecimalPlacesValidator(): ValidatorFn {
  /**
   * @param {AbstractControl} control - Control del formulario a validar
   * @returns {ValidationErrors | null} Objeto de error si la validación falla, null si es válida
   */
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;

    // Si no hay valor, se considera válido
    if (value === null || value === undefined || value === '') {
      return null;
    }

    // Valida el formato usando expresión regular
    const isValid = /^\d+(\.\d{1,2})?$/.test(value);
    return isValid ? null : { twoDecimalPlaces: true };
  };
}
